<template lang="pug">
  div.e-form-modal
    div(:class="modalClass")
      div.modal
        div.modal_container
          div(v-if="showHeader").header
            span(v-if="showCloseModalBtn").close(@click.self="closeModal()")
             //div.breadcrumps Хлебные крошки > 123
            slot(name="header")
          slot
          slot(name="pagination")
          div(v-if="showFooter").footer
            div(v-if="$slots.footer")
              slot(name="footer")
            div(v-else :class="acceptShowDeleteButton ? 'actions-filter-panel' : 'actions-filter-panel actions-filter-panel--right'")
              button(v-if="acceptShowDeleteButton" type="button" :disabled="freezeAllEvents" @click="deleteItem()").actions-filter-panel__button.standart.standart-delete {{$translate(removeBtnLabel)}}
              div
                slot(name="leftActionBtn")
                button(
                v-if="showCancelBtn"
                type="button"
                :disabled="freezeAllEvents"
                @click="closeModal()"
                ).actions-filter-panel__button.standart.standart-noborder {{$translate(cancelBtnLabel)}}
                button(
                v-if="acceptShowSaveButton"
                type="button"
                :disabled="freezeAllEvents"
                @click="submitModalForm"
                ).actions-filter-panel__button.standart {{freezeAllEvents ? $translate(savingBtnLabel) : $translate(saveBtnLabel)}}
</template>

<script>
    import permissionMixin from '../../mixins/permission-mixin.js'
    import modalHelper from './modal-helper'

    export default {
    name: 'e-form-modal',
    mixins: [permissionMixin, modalHelper],
    props: {
      showCancelBtn: {
        type: Boolean,
        default: true
      },
      cancelBtnLabel: {
        type: String,
        default: 'Отмена'
      },
      saveBtnLabel: {
        type: String,
        default: 'Сохранить'
      },
      savingBtnLabel: {
        type: String,
        default: 'Сохранение...'
      },
      removeBtnLabel: {
        type: String,
        default: 'Удалить'
      },
      showFooter: {
        type: Boolean,
        default: true
      },
      showHeader: {
        type: Boolean,
        default: true
      },
      /* условие перепутано */
      hideDeleteButton: {
        type: Boolean,
        default: false
      },
      showSaveButton: {
        type: Boolean,
        default: true
      },
      modalClass: {
        type: String,
        default: 'fixed-overlay fixed-overlay__modal'
      },
      autoRoute: {
        type: Boolean,
        default: true
      },
        showCloseModalBtn: {
            type: Boolean,
            default: true
        }
    },
    created () {
      this.setBodyOverflow('hidden')
    },
    computed: {
      acceptShowDeleteButton () {
        if (this.hideDeleteButton === true && this.userCanDelete === true) {
          return true
        }
        return false
      },
      acceptShowSaveButton () {
        if (this.showSaveButton && this.userCanWrite === true) {
          return true
        }
        return false
      }
    },
    methods: {
      closeModal () {
        if (this.freezeAllEvents === true) {
          return false
        }

          this.$emit('closeModal');
        if (!this.autoRoute) {
          return
        }
        this.redirectToPrev()
      },
      submitModalForm () {
        if (this.freezeAllEvents === true) {
          return false
        }

        this.$emit('submitModalForm')
      },
      deleteItem () {
        if (this.freezeAllEvents === true) {
          return false
        }

        this.$emit('deleteItem')
      },
      setBodyOverflow (value = 'auto') {
        document.body.style.overflow = value
      }
    },
    destroyed () {
      this.setBodyOverflow()
    }
  }
</script>

